import { makeStyles } from '@material-ui/core';
import CheckboxField from 'components/Fields/Checkbox/Checkbox';
import moment from 'moment';
import React, { useState } from 'react';
import { Notify } from 'utils';
import { IoCustomerType } from '../IntellifloCustomerImport';

const useStyles = makeStyles({
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: '24px',
    paddingBottom: '24px'
  }
});

interface CustomerRowProps {
  customer: any;
  selectCustomer: Function;
  removeCustomer: Function;
  index: number;
  caseCustomers: IoCustomerType[];
  selectedCustomers: IoCustomerType[];
  selectedIndex: number;
}

const CustomerRow = ({
  customer,
  selectCustomer,
  removeCustomer,
  index,
  caseCustomers,
  selectedCustomers,
  selectedIndex
}: CustomerRowProps) => {
  const classes = useStyles();
  const [isSelected, setIsSelected] = useState(false);

  return (
    <div
      className={classes.row}
      style={{ backgroundColor: index % 2 === 0 ? 'white' : '#F2F2F2' }}
    >
      <div
        style={{
          width: selectedIndex === 0 ? '20%' : '25%',
          paddingLeft: '24px'
        }}
      >
        <CheckboxField
          label=""
          fullWidth={false}
          meta={{
            touched: false,
            invalid: false,
            error: false
          }}
          input={{
            value: isSelected,
            onChange: () => {
              if (
                caseCustomers.length === 2 ||
                (selectedCustomers.length === 2 && !isSelected)
              ) {
                return Notify.warn(
                  'You have reached the maximum number of clients that can be added',
                  'A maximum of two clients can be added per case'
                );
              }
              if (!isSelected) selectCustomer(customer);
              else removeCustomer(customer);
              setIsSelected(!isSelected);
            },
            checked: isSelected
          }}
        ></CheckboxField>
      </div>
      <div style={{ width: selectedIndex === 0 ? '20%' : '25%' }}>
        {customer && customer.first_name}
      </div>
      <div style={{ width: selectedIndex === 0 ? '20%' : '25%' }}>
        {customer && customer.last_name}
      </div>
      {selectedIndex === 0 && (
        <div style={{ width: '20%' }}>
          {customer && moment(customer.date_of_birth).format('DD-MM-YYYY')}
        </div>
      )}
      <div style={{ width: selectedIndex === 0 ? '20%' : '25%' }}>
        {customer && customer.external_reference}
      </div>
    </div>
  );
};

export default CustomerRow;
